// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  stage: 'd',
  descriptionEnviromente: 'Entorno de pruebas para desarrollo',
  apiBaseUrl: 'https://api-dev.milicenciamedica.cl',
  // Configuración para subir archivos directamente a S3
  s3config:{
    region: 'us-east-1',
    credentials: {
      accessKeyId: 'AKIAUT6UMZ2HATD7CKFX',
      secretAccessKey: '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'
    }
  },
  bucketName: 'resourcesweb-d-pb-use1-dcn',
  tokenProxyUrl : 'https://gtlnlbija5.execute-api.us-east-1.amazonaws.com/sanna-prod-api-token',
  clientId : '6f4h5t738l0gb32qo23g5357sp',
  apiUrl : 'https://gtlnlbija5.execute-api.us-east-1.amazonaws.com/sanna-prod-obtener-licencia-rut'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
